import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import LayoutAdmin from "../LayoutAdmin";
import { useSelector, useDispatch } from "react-redux";
import { setBimbelType } from "../../../redux/features/customerSlice";
export const LessonList = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleChange = (type) => {
    dispatch(setBimbelType(type));
    history.push("/admin/lesson/list");
  };

  return (
    <LayoutAdmin>
      <h4 style={{ margin: "15px" }}>Daftar Paket Bimbel</h4>
      <div className="d-flex" style={{ flexDirection: "row" }}>
        <div
          className="card-container"
          style={{
            cursor: "pointer",
            height: "100px",
          }}
          onClick={(e) => {
            handleChange(1);
          }}
        >
          <div
            style={{
              alignContent: "center",
              alignItems: "center",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <h4 style={{ textDecoration: "underline", marginTop: "30px" }}>
              UKOM
            </h4>
          </div>
        </div>
        <div
          className="card-container"
          style={{
            cursor: "pointer",
            height: "100px",
          }}
          onClick={(e) => {
            handleChange(2);
          }}
        >
          <div
            style={{
              alignContent: "center",
              alignItems: "center",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <h4 style={{ textDecoration: "underline", marginTop: "30px" }}>
              SKB Gizi
            </h4>
          </div>
        </div>
      </div>
    </LayoutAdmin>
  );
};

export default LessonList;
